/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Step_Length_Short_LabelInputs */

const en_exp_step_length_short_label = /** @type {(inputs: Exp_Step_Length_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step`)
};

const de_exp_step_length_short_label = /** @type {(inputs: Exp_Step_Length_Short_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schritt`)
};

/**
* | output |
* | --- |
* | "Step" |
*
* @param {Exp_Step_Length_Short_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_step_length_short_label = /** @type {((inputs?: Exp_Step_Length_Short_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Step_Length_Short_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_step_length_short_label(inputs)
	return de_exp_step_length_short_label(inputs)
});